import { ApolloClient, type OperationVariables } from "@apollo/client";
import { type DocumentNode } from "graphql";

export class CacheRepository {
    public constructor(protected apolloClient: ApolloClient<any>) {}

    public read<CacheQuery>(query: DocumentNode) {
        return this.apolloClient.readQuery<CacheQuery>({
            query,
        });
    }

    public load<Query, QueryVariables extends OperationVariables, CacheQuery, CacheVariables>(
        query: DocumentNode,
        cacheQuery: DocumentNode,
        variables: QueryVariables,
        append: (cacheData: CacheQuery, data: Query) => CacheQuery,
    ) {
        return this.apolloClient
            .query<Query, QueryVariables>({
                query,
                variables,
                fetchPolicy: "no-cache",
            })
            .then(({ data }) => {
                this.append<CacheQuery, CacheVariables>(cacheQuery, (cacheData) => append(cacheData, data));
                return data;
            });
    }

    protected append<CacheQuery, CacheVariables>(query: DocumentNode, append: (cacheData: CacheQuery) => CacheQuery) {
        const prevData = this.apolloClient.readQuery<CacheQuery>({
            query,
        });

        const nextData = append(prevData as CacheQuery);

        this.apolloClient.cache.writeQuery<CacheQuery, CacheVariables>({
            query,
            data: nextData,
        });
    }
}
